import { getEanFromComponents } from "../../subscription-product/selectors/getProductRelationItems.js";
import { CRYSTALLIZE_IDS } from "../../index.js";
import { getComponentContentById } from "@cappelendamm/crystallize-utils";
export const getBookFromProductVariant = (bookProductVariant) => {
    const { sku, name, images, components, product, price, priceVariants } = bookProductVariant;
    const defaultPriceVariant = priceVariants?.find(({ identifier }) => identifier === CRYSTALLIZE_IDS.PRICING.PRICE);
    // With the given data, we can't be sure if the product is a book (ISBN in SKU) or a non-book (EAN field),
    // therefore we need to first get the EAN from the components, if that fails, we use the SKU as ISBN
    const isbnean = getEanFromComponents(components) ?? sku;
    const publicationDate = getComponentContentById(components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK.VARIANT.PUBLICATION_DATE)?.datetime;
    const numberInSeries = getComponentContentById(components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK.VARIANT.SERIES_NUMBER)?.number;
    const subscriptionPublicationDate = getComponentContentById(components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK.VARIANT.SUBSCRIPTION_PUBLICATION_DATE)?.datetime;
    const canBeVisible = getComponentContentById(components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK.VARIANT.CAN_BE_VISIBLE)?.value ?? true;
    return {
        sku,
        name,
        image: images?.find((img) => img?.url)?.url ?? undefined,
        isbnean,
        shapeIdentifier: product?.shape?.identifier,
        publicationDate,
        numberInSeries,
        subscriptionPublicationDate,
        canBeVisible,
        price: price ?? defaultPriceVariant?.price,
    };
};
